import React, { PropTypes, Component } from 'react'
import AutoComplete from 'components/autocomplete'
import styles from './styles'
import Button from 'react-toolbox/lib/button'
import misc from 'utils/misc'

const propTypes = {
  projects: PropTypes.array,
  tasks: PropTypes.array,
  projectShow: PropTypes.array,
  taskShow: PropTypes.object,
  onShowChange: PropTypes.func,
  onDone: PropTypes.func,
  onImportLastWeek: PropTypes.func,
}

class ContentSelect extends Component {

  static ActionType = {
    showProject: 'showProjectType',
    hideProject: 'hideProjectType',
    showTask: 'showTaskType',
    hideTask: 'hideTaskType',
  };

  render () {
    const {
      projectShow,
      taskShow,
      projects,
      tasks,
      onShowChange,
      onDone,
      onImportLastWeek,
    } = this.props
    const enabledProjects = projects.filter(p => p.stage === '1')
    const enabledTasks = tasks.filter(t => t.isEnabled === true)

    const projectNames = misc.getDict(projects, 'name')
    const taskNames = misc.getDict(tasks, 'name')
    const enabledProjectNames = misc.getDict(enabledProjects, 'name')
    const enabledTaskNames = misc.getDict(enabledTasks, 'name')

    // from google spreadsheet color
    const colors =
      [['#D9EAD3', '#93C47D'],
       ['#C9DAF8', '#6D9EEB'],
       ['#FCE5CD', '#F6B26B'],
       ['#D9D2E9', '#8E7CC3'],
       ['#D0E0E3', '#76A5AF'],
       ['#E6B8AF', '#CC4125'],
       ['#FFF2CC', '#FFD966'],
       ['#F4CCCC', '#E06666'],
       ['#CFE2F3', '#6FA8DC'],
       ['#EAD1DC', '#C27BA0'],
      ]

    const autocompleteProjects = []
    for (const pid in enabledProjectNames) {
      if (!(projectShow.indexOf(pid) >= 0)) {
        autocompleteProjects.push(projectNames[pid])
      }
    }

    function findTidByName (name) {
      for (const tid in taskNames) {
        if (taskNames[tid] === name) {
          return tid
        }
      }
      return -1
    }

    function findPidByName (name) {
      for (const pid in projectNames) {
        if (projectNames[pid] === name) {
          return pid
        }
      }
      return -1
    }

    function getColorIndex (pid) {
      let hash = 0
      for (let i = 0; i < pid.length; i++) {
        hash += pid.charCodeAt(i)
      }
      return hash % colors.length
    }

    const ActionType = ContentSelect.ActionType

    function showProject (item) {
      if (item === '') {
        return
      }
      onShowChange(ActionType.showProject, { pid: findPidByName(item) })
    }

    function genHideProject (pid) {
      return () => onShowChange(ActionType.hideProject, { pid })
    }

    function genHideTask (pid, tid) {
      return () => onShowChange(ActionType.hideTask, { pid, tid })
    }
    function genShowTask (pid) {
      return item => {
        if (item === '') {
          return
        }
        onShowChange(ActionType.showTask, { pid, tid: findTidByName(item) })
      }
    }

    return (
      <div className={styles.csBox}>

        <div className={styles.csAddProjectBox}>
          <AutoComplete
            placeholder="輸入專案名稱"
            items={autocompleteProjects}
            onSelect={showProject}
            wide
          />
          <Button className={styles.doneButton} onClick={onDone} icon="done" label="編輯完成" flat />
        </div>

        <div className={styles.csSeparateLine} />

        <div className={styles.csAllProjectBox}>
          {projectShow.length === 0 ?
            <Button
              className={styles.loadButton}
              onClick={onImportLastWeek}
              label="匯入上週設定"
              flat
            /> : null}
          {projectShow.map(pid => {
            const autocompleteTasks = []
            for (const tid in enabledTaskNames) {
              if (!(taskShow[pid].indexOf(tid) >= 0)) {
                autocompleteTasks.push(taskNames[tid])
              }
            }

            return (
                <div
                  style={{ backgroundColor: colors[getColorIndex(pid)][0] }}
                  className={styles.csProjectBox}
                  key={pid}
                >

                  {/* project name box */}
                  <div style={{ backgroundColor: colors[getColorIndex(pid)][1] }}>
                    <div
                      className={styles.projectNamesBox}
                      onClick={genHideProject(pid)}
                    >
                      <span className={styles.nameSpan}>{projectNames[pid]}</span>
                      <span className={styles.deleteCross}>x</span>
                    </div>
                  </div>

                  {/* current tasks */}
                  {taskShow[pid].map(tid =>
                      <div
                        key={`${pid} ${tid}`}
                        className={styles.csContentBox}
                        onClick={genHideTask(pid, tid)}
                      >
                        <span className={styles.nameSpan}>{taskNames[tid]}</span>
                        <span className={styles.deleteCross}>x</span>
                      </div>
                  )}

                  {/* input box for add tasks */}
                  <div className={styles.csAddContentBox}>
                    <AutoComplete
                      placeholder="新增內容代碼..."
                      redHighlight={taskShow[pid].length === 0}
                      items={autocompleteTasks}
                      onSelect={genShowTask(pid)}
                      value={''}
                      wide
                    />
                  </div>

                </div>
              )
          })
          }
        </div>
      </div>
    )
  }

}

ContentSelect.propTypes = propTypes

export default ContentSelect



// WEBPACK FOOTER //
// ./src/app/components/contentSelect/index.jsx